import React, { useState } from 'react';
import { SaveIcon, XIcon } from 'lucide-react';
interface NewRecipeFormProps {
  onSave: (recipe: {
    id: string;
    name: string;
  }) => void;
  onCancel: () => void;
}
export function NewRecipeForm({
  onSave,
  onCancel
}: NewRecipeFormProps) {
  const [recipeData, setRecipeData] = useState({
    id: '',
    name: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Basic validation
    if (!recipeData.id.trim() || !recipeData.name.trim()) {
      alert('Bitte füllen Sie alle Felder aus.');
      return;
    }
    onSave(recipeData);
  };
  const generateRecipeId = () => {
    // Generate a random 5-digit number for the recipe ID
    const randomId = Math.floor(10000 + Math.random() * 90000).toString();
    setRecipeData({
      ...recipeData,
      id: randomId
    });
  };
  return <div className="bg-white rounded-xl shadow-md p-6" data-id="element-1103">
      <div className="flex justify-between items-center mb-6" data-id="element-1104">
        <div data-id="element-1105">
          <h3 className="text-xl font-bold text-gray-800" data-id="element-1106">
            Neues Rezept anlegen
          </h3>
          <p className="text-gray-600" data-id="element-1107">Erstellen Sie ein neues Rezept</p>
        </div>
        <div className="flex gap-2" data-id="element-1108">
          <button onClick={onCancel} className="flex items-center gap-2 bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded-lg transition-colors" data-id="element-1109">
            <XIcon size={18} data-id="element-1110" />
            <span data-id="element-1111">Abbrechen</span>
          </button>
          <button onClick={handleSubmit} className="flex items-center gap-2 bg-[#8DC63F] hover:bg-[#7AB929] text-white px-4 py-2 rounded-lg transition-colors" data-id="element-1112">
            <SaveIcon size={18} data-id="element-1113" />
            <span data-id="element-1114">Speichern</span>
          </button>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1115">
        <div className="grid grid-cols-2 gap-4" data-id="element-1116">
          <div data-id="element-1117">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1118">
              Rezept-Nr.
            </label>
            <div className="flex" data-id="element-1119">
              <input type="text" className="w-full p-2 border border-gray-300 rounded-l-md" value={recipeData.id} onChange={e => setRecipeData({
              ...recipeData,
              id: e.target.value
            })} placeholder="z.B. 10635" required data-id="element-1120" />
              <button type="button" onClick={generateRecipeId} className="bg-blue-500 hover:bg-blue-600 text-white px-3 rounded-r-md" data-id="element-1121">
                Generieren
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-1" data-id="element-1122">
              Eindeutige Nummer für das Rezept
            </p>
          </div>
          <div data-id="element-1123">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1124">
              Bezeichnung
            </label>
            <input type="text" className="w-full p-2 border border-gray-300 rounded-md" value={recipeData.name} onChange={e => setRecipeData({
            ...recipeData,
            name: e.target.value
          })} placeholder="z.B. Gustoria Lasagne" required data-id="element-1125" />
            <p className="text-xs text-gray-500 mt-1" data-id="element-1126">Name des Rezepts</p>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-6" data-id="element-1127">
          <p className="text-sm text-gray-600 mb-4" data-id="element-1128">
            Nach dem Speichern werden Sie direkt zur Rezeptbearbeitung
            weitergeleitet, um Komponenten hinzuzufügen.
          </p>
        </div>
      </form>
    </div>;
}